<!--
  版本： V1.1
  使用方法
  import singleUpload from '@/components/Upload/singleUpload'
  <singleUpload v-model="form.logo" />
  <singleUpload v-model="form.avataUrl" sizetxt="哈哈哈" />
-->
<template>
  <div>
    <el-upload
      :action="dataObj.host"
      :data="dataObj"
      :list-type="listType"
      :file-list="fileList"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-success="handleUploadSuccess"
      :on-exceed="handleExceed"
      :on-preview="handlePictureCardPreview"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip" style="color: #E6A23C;">{{ sizetxt }}</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'SingleUpload',
  props: {
    value: {
      type: String,
      default: null
    },
    sizetxt: {
      type: String,
      default: '只能上传jpg/png文件，且不超过10MB'
    },
    typeArray: {
      type: Array,
      default: function () {
        return ['jpg', 'png', 'jpeg']
      }
    },
    fileSize: {
      type: Number,
      default: 100
    },
    imgWidth: {
      type: Number,
      default: null
    },
    imgHeight: {
      type: Number,
      default: null
    },
    isImg: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dataObj: {
        key: '',
        policy: '',
        ossaccessKeyId: '',
        ossaccesskeySecret: '',
        signature: '',
        success_action_status: 200,
        bucket: '',
        region: '',
        host: ''
      },
      dialogImageUrl: '',
      dialogVisible: false,
      oss_path: process.env.VUE_APP_OSS_PATH
      // fileList: null
    }
  },
  computed: {
    fileList () {
      console.log('computed')
      console.log(this.value)
      let imageName = null
      if (this.value !== null && this.value !== '') {
        imageName = this.value.substr(this.value.lastIndexOf('/') + 1)
        const nameArray = imageName.split('_')
        imageName = nameArray[nameArray.length - 1]
        imageName = decodeURI(imageName)
      }
      let imageUrl = null
      if (this.value !== null && this.value !== '') {
        imageUrl = this.value
      }
      const img = []
      if (imageName !== null && imageUrl !== null) {
        img.push({ name: imageName, url: imageUrl })
      }
      return img
    }
  },
  methods: {
    emitInput (data) {
      this.$emit('input', data)
    },
    handleRemove (file, fileList) {
      this.emitInput()
    },
    fileListRefresh () {
      if (this.value) {
        for (let i = 0; i < this.value.length; i++) {
          this.fileList.push({ url: this.value[i] })
        }
      }
    },
    beforeUpload (file) {
      // const _self = this
      // 分别拿到扩展名和大小，做限制判断，过不去的就不上传了
      const fileType = file.name.substr(file.name.lastIndexOf('.') + 1)
      const fileSize = file.size / 1024 / 1024
      if (!this.checkFileSize(fileSize) || !this.checkFileType(fileType)) {
        this.$message.warning(this.sizetxt)
        return false
      }
      // 这里分别对图片的宽高还有后台的凭证做了promise判定,all or nothing!!!
      return Promise.all([
        this.getImgWidth(file),
        this.getImgHeight(file),
        this.getPolicyFromBackend(file)
      ])
    },
    // 用来判断图片宽度是否符合要求
    getImgWidth (file) {
      const localWidth = this.imgWidth
      const _URL = window.URL || window.webkitURL
      return new Promise((resolve, reject) => {
        if (!this.imgWidth) {
          console.log('imgWidth为空')
          resolve()
        }

        const img = new Image()
        img.onload = function () {
          console.log(this.width)
          console.log(localWidth)
          this.width === localWidth ? resolve() : reject(new Error())
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return true
        },
        () => {
          this.$message.error('图片宽度不符合规定')
          return Promise.reject(new Error())
        }
      )
    },
    // 用来判断图片高度是否符合要求
    getImgHeight (file) {
      const localHeight = this.imgHeight
      const _URL = window.URL || window.webkitURL
      return new Promise((resolve, reject) => {
        if (!this.imgHeight) {
          console.log('imgHeight为空')
          resolve()
        }

        const img = new Image()
        img.onload = function () {
          console.log(this.height)
          console.log(localHeight)
          this.height === localHeight ? resolve() : reject(new Error())
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return true
        },
        () => {
          this.$message.error('图片高度不符合规定')
          return Promise.reject(new Error())
        }
      )
    },
    // 用来从后台拿到文件服务器所需的凭证
    getPolicyFromBackend (file) {
      return new Promise((resolve, reject) => {
        this.$get(this.$url.submitBaseVerification.text)
          .then(res => {
            res = res.data
            this.dataObj.key = res.data.dir + this.getUUID() + file.name
            this.dataObj.policy = res.data.policy
            this.dataObj.ossaccessKeyId = res.data.accessid
            this.dataObj.ossaccesskeySecret = res.data.accesskeysecret
            this.dataObj.signature = res.data.signature
            this.dataObj.region = res.data.region
            this.dataObj.host = res.data.host
            resolve(true)
          })
          .catch(() => reject(new Error('error')))
      })
    },
    getUUID () {
      return 'xxxxxxxx4xxxyxxxxxxx'.replace(/[xy]/g, c => {
        return (c === 'x'
          ? (Math.random() * 16) | 0
          : 'r&0x3' | '0x8'
        ).toString(16)
      })
    },
    checkFileType (type) {
      if (this.typeArray.includes(type)) {
        return true
      }
      return false
    },
    checkFileSize (size) {
      if (this.fileSize >= size) {
        return true
      }
      return false
    },
    handleUploadSuccess (response, file, fileList) {
      console.log('handleUploadSuccess')
      // this.fileList = fileList
      console.log(fileList)
      this.emitInput(this.dataObj.host + '/' + this.dataObj.key)
    },
    handlePictureCardPreview (file) {
      if (!this.isImg) {
        window.open(file.url)
      } else {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      }
    },
    handleExceed () {
      this.$message({
        message: '最多只能上传个视频',
        type: 'warning',
        duration: 1000
      })
    }
  }
}
</script>
<style>
</style>
